import { render, staticRenderFns } from "./ImportTaskCreate.vue?vue&type=template&id=66b83df5"
import script from "./ImportTaskCreate.vue?vue&type=script&lang=js"
export * from "./ImportTaskCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.15_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports